<div *ngIf="!showList && !integrated" class="intro ion-text-center">
    <img src="assets/img/thought-record/challenge-negative-thoughts.png"/>
    <h1 class="hero-title" [innerHTML]="'thoughtRecord.assessment.challengeNegativeThoughts' | translate"></h1>
    <p class="paragraph-15">{{'thoughtRecord.assessment.challengeNegativeThoughtsDescription' | translate}}</p>
    <ion-button color="secondary" fill="clear" (click)="showList = true">
        {{'thoughtRecord.assessment.start'| translate}}
    </ion-button>
</div>

<ng-container *ngIf="showList || integrated">
    <div [class.scroll]="!integrated">
        <h2 class="block-title" *ngIf="!integrated && question">{{question.label}}</h2>
        <ion-list lines="none">
            <div *ngFor="let option of options" class="item-container">
                <ion-item [class.checked]="option.checked && !integrated"
                          (click)="change(option)">
                    <ion-label class="block-title">
                        <div>{{option.label}}</div>
                        <ion-button class="link-small" fill="clear" color="primary" size="extra-small"
                                    [routerLink]="['/thought-record/challenge-negative-thought', option.value]">
                            {{'thoughtRecord.assessment.challengeNegativeThoughtsDetail' | translate}}
                        </ion-button>
                    </ion-label>
                    <img slot="end" [src]="'assets/img/thought-record/cognitive-distortions/'+option.value+'.png'"/>
                </ion-item>
                <ion-button *ngIf="integrated && !readOnly" class="remove" size="extra-small" color="primary"
                            (click)="remove(option)">
                    <ion-icon class="icon haleo-trash"></ion-icon>
                </ion-button>
            </div>
        </ion-list>
    </div>
    <ion-button *ngIf="!integrated"
                class="next"
                color="secondary"
                fill="solid"
                [disabled]="!enableNext" (click)="continue()">
        {{'thoughtRecord.assessment.next' | translate}}
    </ion-button>
    <ion-button *ngIf="integrated && !readOnly && options && options.length < optionsCount"
                expand="block"
                fill="outline"
                color="primary"
                (click)="add()">
        <ion-icon slot="start" class="icon haleo-plus"></ion-icon>
        {{'thoughtRecord.assessment.addCognitiveDistortion' | translate}}
    </ion-button>
</ng-container>
